import {FooterType} from "../app/FooterType";
import {otpDialog, PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {LoginActions} from "./LoginActions";
import {loginWServiceActions} from "../../services/ws/login/loginWServiceActions";
import {OTPDialogState} from "@pledger/frontend-commons/dist/ui/components/dialogBoxes/OTPDialog/OTPDialogReducer";
import {webAuthnWServiceActions} from "../../services/ws/webAuthn/webAuthnWServiceActions";

const webAuthnAvailable = (state : boolean = false, action : PledgerAction) => {
    switch (action.type) {
        case LoginActions.WEBAUTHN_AVAILABLE_ACTION.type:
            return action.payload.isAvailable;
        default:
            return state;
    }
};

const footerType = (state = FooterType.THIN, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.THIN;
    }
};

const email = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case LoginActions.CHANGE_EMAIL_ACTION.type:
            return action.payload.email;
        default:
            return state;
    }
};

const password = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case LoginActions.CHANGE_PASSWORD_ACTION.type:
            return action.payload.password;
        default:
            return state;
    }
};




const dataErrorMessage = (state = '', action : PledgerAction) => {
    switch (action.type) {
        case webAuthnWServiceActions.START_AUTHENTICATION_FAILED_ACTION.type:
        case webAuthnWServiceActions.FINISH_AUTHENTICATION_FAILED_ACTION.type:
        case LoginActions.WEBAUTHN_AUTHENTICATION_FAILED_ACTION.type:
            return 'Impossible de valider la clé';
        case loginWServiceActions.LOGIN_FAILED_ACTION.type:
            return 'Login ou mot de passe incorrect(s)';
        case LoginActions.CHANGE_EMAIL_ACTION.type:
            return '';
        case LoginActions.CHANGE_PASSWORD_ACTION.type:
            return '';
        default:
            return state;
    }
};


const dataError = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case webAuthnWServiceActions.START_AUTHENTICATION_FAILED_ACTION.type:
        case webAuthnWServiceActions.FINISH_AUTHENTICATION_FAILED_ACTION.type:
        case LoginActions.WEBAUTHN_AUTHENTICATION_FAILED_ACTION.type:
            return true;

        case loginWServiceActions.LOGIN_FAILED_ACTION.type:
            return true;
        case LoginActions.CHANGE_EMAIL_ACTION.type:
            return false;
        case LoginActions.CHANGE_PASSWORD_ACTION.type:
            return false;
        default:
            return state;
    }
};

export interface LoginPageComponentState extends PledgerPageComponentState {
    email: string;
    password: string;
    dataError: boolean;
    dataErrorMessage: string;
    otpDialog: OTPDialogState;
    webAuthnAvailable:boolean;
}

export const login : Reducer = (state={},action)=>{
    return{
        footerType: footerType(state.footerType, action),
        email: email(state.email, action),
        password: password(state.password, action),
        dataError: dataError(state.dataError, action),
        dataErrorMessage: dataErrorMessage(state.dataErrorMessage, action),
        otpDialog:otpDialog(state.otpDialog,action),
        webAuthnAvailable:webAuthnAvailable(state.webAuthnAvailable,action),
    }
}
